module.exports = __webpack_public_path__ + "img/handdrawn-cloud.2fb25abf.svg";